import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import labProBgIcon from "@/assets/labpro-background.svg";
import { Spinner } from "@/components/Spinner";
import { Row } from "./Row";
import { Stack } from "./Stack";

interface EmptyPageProps {
  title: string;
  subTitle: string;
  children?: ReactNode;
  loading?: boolean;
}

const EmptyPage = ({ title, subTitle, children, loading }: EmptyPageProps) => {
  const { t } = useTranslation("components");
  return (
    <Stack align="center" className="justify-center min-h-[calc(100vh-200px)] p-component-large">
      <Stack align="center" className="gap-[56px] max-w-[510px]">
        <Row align="center" justify="center" className="w-[270px] h-[211px]">
          {loading ? (
            <Spinner size={80} />
          ) : (
            <img src={labProBgIcon} alt={t("emptyPage.logoAlt")} className="w-full h-full object-contain" />
          )}
        </Row>
        <Stack align="center" gap="component-large" className="text-center">
          <h1 className="m-0 text-[44px] font-normal leading-[110%] tracking-[-0.5px] text-muted-foreground">
            {title}
          </h1>
          <p className="m-0 text-[18px] font-normal leading-[150%] text-foreground">{subTitle}</p>
        </Stack>
        {children}
      </Stack>
    </Stack>
  );
};

export default EmptyPage;
